/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetComparisonAlbumsModel, IMappers, TGetComparisonAlbumsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetComparisonAlbumsResponse } from '../../entities/v1_get_comparison_albums/GetComparisonAlbumsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetComparisonAlbumsModel(): TGetComparisonAlbumsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'property-comparison',
    pathApi: '/v1/get-comparison-albums/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IGetComparisonAlbumsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetComparisonAlbums<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetComparisonAlbumsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetComparisonAlbumsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetComparisonAlbumsModel(),
    config,
  )) as FetchResponse<TGetComparisonAlbumsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetComparisonAlbumsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetComparisonAlbumsResponse>;
}
